import { FC, useRef, memo, useMemo } from "react";
import { IonButton, IonModal } from "@ionic/react";
import { shallow } from "zustand/shallow";

import "./WLDialog.scss";
import { useDialogStore } from "./dialogs";

interface WLDialogProps {}

const WLDialog: FC<WLDialogProps> = () => {
  const modal = useRef<HTMLIonModalElement>(null);

  const [
    isOpen,
    component,
    type,
    confirmLabel,
    confirmNoLabel,
    confirmYesLabel,
    dialogIcon,
    darkBackground,
    noDismiss,
    reverseColorOption,
    hideDialog,
    onPressNo,
    onPressYes,
    onPressConfirm,
  ] = useDialogStore(
    (state) => [
      state.isOpen,
      state.component,
      state.type,
      state.confirmLabel,
      state.confirmNoLabel,
      state.confirmYesLabel,
      state.dialogIcon,
      state.darkBackground,
      state.noDismiss,
      state.reverseColorOption,
      state.hideDialog,
      state.onPressNo,
      state.onPressYes,
      state.onPressConfirm,
    ],
    shallow
  );

  const dismiss = () => {
    modal.current?.dismiss();
    hideDialog();
  };

  const renderDialogType = useMemo(() => {
    const actionButtonsDisplay = () => {
      switch (type) {
        case "Confirm":
          return (
            <IonButton
              className="confirm-btn"
              onClick={() => {
                if (onPressConfirm) onPressConfirm();
                if (!noDismiss) dismiss();
              }}
            >
              {confirmLabel ?? "OK"}
            </IonButton>
          );
        case "YesNo":
          return (
            <div
              className={`yes-no-cta ${
                !!reverseColorOption ? "reverse-color" : ""
              }`}
            >
              <IonButton
                className="confirm-btn"
                onClick={() => {
                  if (onPressNo) onPressNo();
                  if (!noDismiss) dismiss();
                }}
              >
                {confirmNoLabel ?? "No"}
              </IonButton>
              <IonButton
                className="confirm-btn yes"
                onClick={() => {
                  if (onPressYes) onPressYes();
                  if (!noDismiss) dismiss();
                }}
              >
                {confirmYesLabel ?? "Yes"}
              </IonButton>
            </div>
          );
        default:
          break;
      }
    };
    return (
      <>
        <div className="dialog-icon">{dialogIcon ?? <></>}</div>
        <div className="dialog-content">
          {component}
          {actionButtonsDisplay()}
        </div>
      </>
    );
  }, [type, component]);

  return (
    <>
      <IonModal
        id="wl-modal"
        className={`wl-modal ${darkBackground ? "dark" : ""}`}
        ref={modal}
        isOpen={isOpen}
        onDidDismiss={dismiss}
        {...(noDismiss !== undefined && { backdropDismiss: !noDismiss })}
      >
        <div className="dialog-container">{renderDialogType}</div>
      </IonModal>
    </>
  );
};

export default memo(WLDialog);
